import type { AssessorSlide, MarkingStatus } from './types';

export function markingStatus(correct: boolean | null | undefined): MarkingStatus {
  if (correct === true) {
    return 'CORRECT';
  }

  if (correct === false) {
    return 'REVISION';
  }

  return 'UNAVAILABLE';
}

export function needsRevisionFeedback(slide: AssessorSlide): boolean {
  return slide.isManuallyAssessable && slide.correct === false && !slide.hasFeedback;
}

export function needsAssessorAttention(slide: AssessorSlide): boolean {
  return (slide.isManuallyAssessable && slide.correct === null) || needsRevisionFeedback(slide);
}
